// extracted by mini-css-extract-plugin
export default {"indicatorGroup":"CarouselIndicatorGroup_indicatorGroup__GsdQm","indicator":"CarouselIndicatorGroup_indicator__9nELX","active":"CarouselIndicatorGroup_active__2058p"};